import { usePunditUserContext } from "@/react/contexts";

export const useIsVisualEmailBuilderThemesEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.visual_email_builder_enabled);
};
